import React from 'react'
import './app-loading.css'

const LoadingScreenView = () => (
  <div className="app-loading">
    <div className="app-loading__loader"> </div>
  </div>
)
export default LoadingScreenView
